import React from 'react';
//import { Link } from "react-router-dom";
//import '../css/about_section.css'


class BrandSection extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            aboutTopImg: "",
            aboutTitle: "",
            aboutDescription: "",
            aboutLeftImg: "",
            storeList: [],
            section_text: ""
        }
    }

    
    componentWillMount() {
        //console.log("~~ BrandSection ~~")
        //console.log(this.props.context)
        if (this.props.context !== undefined && this.props.context !== "") {
            if (this.props.context.about !== undefined && this.props.context.about !== "") {
                let aboutTopImg = "";
                let aboutTitle = "";
                let aboutDescription = "";
                let aboutLeftImg = "";
                let storeList = [];
                let section_text = "";

                if (this.props.context.about.aboutTopImg !== undefined && this.props.context.about.aboutTopImg !== "") {
                    aboutTopImg = this.props.context.about.aboutTopImg;
                }
                if (this.props.context.about.aboutTitle !== undefined && this.props.context.about.aboutTitle !== "") {
                    aboutTitle = this.props.context.about.aboutTitle;
                }
                if (this.props.context.about.aboutDescription !== undefined && this.props.context.about.aboutDescription !== "") {
                    aboutDescription = this.props.context.about.aboutDescription;
                }
                if (this.props.context.about.aboutLeftImg !== undefined && this.props.context.about.aboutLeftImg !== "") {
                    aboutLeftImg = this.props.context.about.aboutLeftImg;
                }

                if (this.props.context.about.storeList !== undefined && this.props.context.about.storeList.length) {
                    storeList = this.props.context.about.storeList;
                }

                if (this.props.context.about.section_text !== undefined && this.props.context.about.section_text !== "") {
                    section_text = this.props.context.about.section_text;
                }

                this.setState({
                    aboutTopImg: aboutTopImg,
                    aboutTitle: aboutTitle,
                    aboutDescription: aboutDescription,
                    aboutLeftImg: aboutLeftImg,
                    storeList: storeList,
                    section_text: section_text
                })
            }
        }
    }


    render() {

        let list = "";
        if (this.state.storeList.length) {
            list = this.state.storeList.map((item, i) => {
                return (
                    <div className="col-md-6 col-sm-6 col-xs-12" key={i}>
                        <div className="funtion_post_wrap"><img src={item.storeImg} alt="" /></div>
                        <div className="info_content_wrap">
                            <div className="info_title">{item.storeName}</div>
                            <div className="info_content">{item.storeAddr}</div>
                        </div>
                    </div>
                )
            })
        }

        return (
            <div className="brandsection-frame">
                <section>
                    <div className="secondary_banner_wrap">
                        <div>
                            <img src={this.state.aboutTopImg} alt="" />
                        </div>
                    </div>
                </section>
                <section>
                    <div className="container">
                        <div className="intro_wrap_1">
                            <div className="intro_title_2">關<br />於</div>
                            <div className="intro_content_1">{this.state.aboutTitle}</div>
                            <div className="intro_content_line_1"></div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container funtion_post_area">
                        <div className="row">
                            <div className="col-md-6 col-sm-6 col-xs-12">
                                <div className="funtion_post_wrap"><img src={this.state.aboutLeftImg} alt="" /></div>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-12">
                                <div className="info_content_2">{this.state.aboutDescription}</div>
                            </div>
                        </div>
                        <div className="intro_wrap_1">
                            <div className="intro_title_3">{this.state.section_text}</div>
                            <div className="intro_content_line_2"></div>
                        </div>
                        <div className="row">
                            {list}
                        </div>
                        <div className="info_line_1"></div>
                        <div className="info_line_2"></div>
                    </div>
                </section>
            </div>
        )
    }
}


export default BrandSection



// WEBPACK FOOTER //
// ./src/component/brandSection.js